/*
  Vanilla-JS gallery controller for snippets/product__images-simple.liquid.
  Replaces Flickity for this gallery variant: no carousel library, no
  jQuery dependency for the core swipe/thumbnail/arrow behavior. jQuery is
  only touched (if present) to reuse the existing $.fn.zoom plugin, since
  that's unrelated to Flickity and already loaded sitewide.
*/
(function () {
  'use strict';

  function initSimpleGallery(root) {
    var main = root.querySelector('[data-simple-gallery-main]');
    var track = root.querySelector('[data-simple-gallery-track]');
    if (!main || !track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll(':scope > .product-gallery__image'));
    if (!slides.length) return;

    var thumbsWrap = root.querySelector('[data-simple-gallery-thumbs]');
    var thumbs = thumbsWrap
      ? Array.prototype.slice.call(thumbsWrap.querySelectorAll('[data-simple-gallery-thumb]'))
      : [];
    var prevBtn = main.querySelector('[data-simple-gallery-prev]');
    var nextBtn = main.querySelector('[data-simple-gallery-next]');
    var videoLoop = root.getAttribute('data-video-loop') === 'true';
    var zoomEnabled = root.getAttribute('data-enable-zoom') === 'true';

    var activeIndex = 0;
    var programmaticScroll = false;
    var programmaticScrollTimer;

    function pauseMedia(slide) {
      var mediaType = slide.getAttribute('data-media-type');
      if ((mediaType === 'video' || mediaType === 'external_video') && window.videoPlayers) {
        window.videoPlayers.forEach(function (player) {
          var video = slide.querySelector('video, iframe');
          var matches = video && ((player.id && player.id === video.id)
            || (player.media && video.id && player.media.id === video.id));
          if (matches && typeof player.pause === 'function') player.pause();
        });
      }
      if (mediaType === 'model' && window.PXUTheme && window.PXUTheme.productMedia && window.PXUTheme.productMedia.models) {
        var modelViewer = slide.querySelector('model-viewer');
        window.PXUTheme.productMedia.models.forEach(function (model) {
          if (modelViewer && model.container === modelViewer && typeof model.pause === 'function') {
            model.pause();
          }
        });
      }
    }

    function activateMedia(slide) {
      var mediaType = slide.getAttribute('data-media-type');
      if (mediaType !== 'video' && mediaType !== 'external_video') return;
      var mediaEl = slide.querySelector('video, iframe');
      if (!mediaEl || !window.videoPlayers) return;

      window.videoPlayers.forEach(function (player) {
        var matches = (player.id && player.id === mediaEl.id)
          || (player.media && mediaEl.id && player.media.id === mediaEl.id);
        if (matches) {
          player.loop = videoLoop;
          if (typeof player.play === 'function') player.play();
        }
      });
    }

    function setActive(index) {
      if (index < 0 || index >= slides.length) return;
      if (index === activeIndex && slides[index].classList.contains('is-selected')) return;

      slides.forEach(function (slide, i) {
        var isActive = i === index;
        slide.classList.toggle('is-selected', isActive);
        if (!isActive) pauseMedia(slide);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-nav-selected', i === index);
      });

      activeIndex = index;
      activateMedia(slides[index]);
    }

    function scrollToIndex(index, behavior) {
      var slide = slides[index];
      if (!slide) return;
      programmaticScroll = true;
      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: behavior || 'smooth',
      });
      clearTimeout(programmaticScrollTimer);
      programmaticScrollTimer = setTimeout(function () {
        programmaticScroll = false;
      }, 600);
      setActive(index);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var next = activeIndex - 1 < 0 ? slides.length - 1 : activeIndex - 1;
        scrollToIndex(next);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex((activeIndex + 1) % slides.length);
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        scrollToIndex(i);
      });
      thumb.addEventListener('keypress', function (event) {
        if (event.which === 13) scrollToIndex(i);
      });
    });

    // Keep the active slide/thumbnail synced when the visitor swipes/drags
    // the track directly rather than using the arrows or thumbnails.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (programmaticScroll) return;
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              var index = slides.indexOf(entry.target);
              if (index > -1) setActive(index);
            }
          });
        },
        { root: track, threshold: 0.6 },
      );
      slides.forEach(function (slide) {
        observer.observe(slide);
      });
    }

    // Zoom-on-hover, mirroring Product.enableZoom in z__jsProduct.js but
    // without the Flickity/Product-class coupling.
    if (zoomEnabled && window.jQuery) {
      var setupZoom = function (img) {
        var zoomSrc = img.getAttribute('data-zoom-src');
        if (!zoomSrc || img.dataset.zoomReady) return;
        img.dataset.zoomReady = 'true';

        window.jQuery(img)
          .wrap('<span class="zoom-container"></span>')
          .css('display', 'block')
          .parent()
          .zoom({ url: zoomSrc, touch: false, magnify: 1 });
      };

      slides.forEach(function (slide) {
        var img = slide.querySelector('img.lazyloaded, img.lazyload');
        if (!img) return;
        if (img.classList.contains('lazyloaded')) {
          setupZoom(img);
        } else {
          img.addEventListener('lazyloaded', function () {
            setupZoom(img);
          });
        }
      });
    }

    setActive(0);
  }

  function init() {
    var galleries = document.querySelectorAll('[data-simple-gallery]');
    galleries.forEach(function (root) {
      initSimpleGallery(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
